import { Container } from "reactstrap";
import BannerMask from "./BannerMask";

type InnerBannerProps = {
  title: string;
  description: string;
};

function InnerBanner({ title, description }: InnerBannerProps) {
  return (
    <div className="inner-banner-wrapper">
       <BannerMask /> 
      <div className="inner-banner" data-aos="fade-up">
        <Container>

        <div className="content">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
        </Container>
      </div>
    </div>
  );
}

export default InnerBanner;
